import Vue from 'vue'
import Router from 'vue-router'
import $ from 'jquery'

Vue.use(Router)

const homeRoute = 'analytics'

const routes = [{
  path: '/auth',
  name: 'auth',
  component: () => import('../views/Auth.vue'),
  meta: {
    guest: true,
    layout: 'no-navbar'
  }
}, {
  path: '/forget',
  name: 'Forget',
  component: () => import('../views/Forget.vue'),
  meta: {
    guest: true,
    layout: 'no-navbar'
  }
}, {
  path: '/resetpassword',
  name: 'Reset',
  component: () => import('../views/ResetPassword.vue'),
  meta: {
    guest: true,
    layout: 'no-navbar'
  }
}, {
  path: '/',
  name: 'landing',
  redirect: {
    name: homeRoute
  }
}, 
{
  path: '/analytics',
  name: 'analytics',
  component: () => import('../views/Stats.vue'),
  meta: {
    requiresAuth: true
  }
}, 
{
path: '/defects',
name: 'defects',
component: () => import('../views/Defects.vue'),
meta: {
  requiresAuth: true,
  // roleRestricted: ["Supervisor", "Command Center"]
}
}, {
  path: '/social',
  name: 'social',
  component: () => import('../views/Social.vue'),
  meta: {
    requiresAuth: true,
    roleRestricted: ["Supervisor"]
  }
}, {
  path: '/inbox/:id?',
  name: 'inbox',
  component: () => import('../views/Inbox.vue'),
  meta: {
    requiresAuth: true,
    roleRestricted: ["Supervisor", "Command Center"]
  }
}, {
  path: '/dashcam',
  name: 'dashcam',
  component: () => import('../views/Dashcam.vue'),
  meta: {
    requiresAuth: true,
    roleRestricted: ["Command Center"]
  }
}, {
  path: '/live',
  name: 'live',
  component: () => import('../views/Live.vue'),
  meta: {
    requiresAuth: true
  }
}, 
// {
  //   path: '/live',
  //   name: 'live',
  //   component: () => import('../views/Live.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // }, 
  // {
  //   path: '/analytics',
  //   name: 'analytics',
  //   component: () => import('../views/Analytics.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // }, 
  {
  path: '/reports',
  name: 'reports',
  component: () => import('../views/Reports.vue'),
  meta: {
    requiresAuth: true,
    // roleRestricted: ["Supervisor", "Command Center"]
  }
}, {
  path: '/cases/:id?',
  name: 'cases',
  component: () => import('../views/Cases.vue'),
  meta: {
    requiresAuth: true
  }
}, {
  path: '/inspection',
  name: 'inspection',
  component: () => import('../views/Inspection.vue'),
  meta: {
    requiresAuth: true,
    roleRestricted: ["Supervisor", "Command Center"]
  }
}]

let router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  const navbar = $(".navbar-collapse")

  if (navbar) {
    navbar.collapse("hide")
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        path: '/auth',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      let user = JSON.parse(localStorage.getItem('user'))

      if (to.matched.some(record => record.meta.isAdmin)) {
        if (user.isAdmin == 1) {
          next()
        } else {
          next({
            name: homeRoute
          })
        }
      } else {
        if (to.matched.some(record => record.meta.roleRestricted)) {
          if (to.meta.roleRestricted.includes(user.role.name)) {
            let allowedRoutes = routes.filter(route => route.meta &&
              route.meta.requiresAuth &&
              (!route.meta.roleRestricted || !route.meta.roleRestricted.includes(user.role.name)))

            router.replace({
              name: allowedRoutes[0].name
            })
          } else {
            next()
          }
        } else {
          next()
        }
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next()
    } else {
      next({
        name: homeRoute
      })
    }
  } else {
    next()
  }
})

export default router